import React from "react";

import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";
import { useUserBusiness } from "@tudigo-monorepo/tudigo-session";
import { useGetCircles } from "@tudigo-monorepo/web-tudigo-api-client";
import { Tabs } from "@tudigo-monorepo/web-tudigo-components";

export const CirclesListingPageHead = () => {
  const { t } = useTranslation();
  const listingCirclesFields =
    "id,content,industries,icon_border_color,maturities,mentorings,territories,statistics,leaders,my_membership";

  const { data: allCircles } = useGetCircles({
    fields: listingCirclesFields,
  });

  const { user } = useUserBusiness();

  return (
    <div className="container mx-auto mt-6">
      <div className="flex flex-col gap-1">
        <h1 className="font-obviously text-primary text-xl font-semibold">
          {t("circles_listing_page.title")}
        </h1>
        <p className="text-dark-1 ">{t("circles_listing_page.subtitle")}</p>
      </div>
      <Tabs
        tabs={[
          {
            name: t("circles_listing_page.tabs.all_circles"),
            redirectTo: "all",
            badge: allCircles?.pagination?.count
              ? {
                  children: String(allCircles?.pagination?.count),
                  asChip: "normal",
                  variant: "info",
                }
              : undefined,
          },
          {
            name: t("circles_listing_page.tabs.my_circles"),
            redirectTo: "my-circles",
            badge: user?.myCircles?.length
              ? {
                  children: String(user?.myCircles?.length),
                  asChip: "normal",
                  variant: "info",
                }
              : undefined,
          },
        ]}
        className="mt-6"
      />
    </div>
  );
};
